import { ShieldBugIcon } from './ShieldBugIcon';

/**
 * author: Michael Richins
 * id 1FB00AC4-94AE-4677-8F7F-0B6A47F7382C
 * name shield-bug
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-bug.svg
 * tags
 */
export const AntivirusIcon = ShieldBugIcon;
export default AntivirusIcon